// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--EDh5R","FooterContent":"Footer-module--FooterContent--sWslH","Title":"Footer-module--Title--2agTZ"};